import React, { useEffect, useRef, useState } from 'react';
import classes from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../../contexts/kato.context';
import { IBudgetInvestmentProjectStats } from '../../../../types/kato.types';
import { getLang } from '../../../../helpers/utils';
import { ArrowLeftIcon, SortIcon } from '../../../../assets/icons';
import FullscreenClose from './fullscreen-close.component';
import IFrameFullscreen from './iframe-fullscreen.component';

const baseClass = 'budget-investment-projects-fullscreen';
const translationKey = 'cards.budget-investment-projects-card';

const columnKeys: string[] = [
  'name',
  'city',
  'realizationDate',
  'totalPrice',
  'rb',
  'currentYearTotalSum',
  'faktsumCurrYear',
  'percentTekGod',
  'developmentShare',
];

const BudgetInvestmentProjectsFullscreen = () => {
  const { t } = useTranslation();
  const { budgetInvestmentProjectStats, budgetInvIframe } =
    useKato().katoGeneralInfo;
  const tableRef = useRef<HTMLTableElement>(null);

  const [sortedData, setSortedData] = useState<IBudgetInvestmentProjectStats[]>(
    [],
  );
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: 'asc' | 'desc';
  } | null>(null);

  const [link, setLink] = useState<string>('');

  useEffect(() => {
    budgetInvIframe?.iframeUrlAltExp &&
      setLink(budgetInvIframe.iframeUrlAltExp);
  }, [budgetInvIframe]);

  useEffect(() => {
    if (budgetInvestmentProjectStats?.length) {
      const initial = [...budgetInvestmentProjectStats].sort(
        (a, b) => b.developmentShare - a.developmentShare,
      );
      setSortedData(initial);
    }
  }, [budgetInvestmentProjectStats]);

  // if (
  //   !budgetInvestmentProjectStats ||
  //   !budgetInvestmentProjectStats.length ||
  //   !budgetInvIframe?.iframeUrlAltExp
  // )
  //   return null;

  const scrollToTop = () => {
    tableRef.current?.scrollTo({ behavior: 'smooth', top: 0 });
  };

  const handleSort = (key: string) => {
    const direction =
      sortConfig?.key === key && sortConfig.direction === 'asc'
        ? 'desc'
        : 'asc';

    const sorted = [...sortedData].sort((a, b) => {
      let valA: string | number =
        a[key as keyof IBudgetInvestmentProjectStats] ?? '';
      let valB: string | number =
        b[key as keyof IBudgetInvestmentProjectStats] ?? '';

      if (key === 'name') {
        valA = a[`name${getLang()}`] ?? '';
        valB = b[`name${getLang()}`] ?? '';
      }

      if (typeof valA === 'string' && typeof valB === 'string') {
        return direction === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      const numA = typeof valA === 'number' ? valA : 0;
      const numB = typeof valB === 'number' ? valB : 0;
      return direction === 'asc' ? numA - numB : numB - numA;
    });

    setSortedData(sorted);
    setSortConfig({ key, direction });
  };

  return (
    <>
      {budgetInvIframe?.iframeUrlAltExp ? (
        <IFrameFullscreen link={link} title={'Tax Fullscreen'} />
      ) : (
        <div className={classes[baseClass]}>
          <FullscreenClose />
          <div className={classes[`${baseClass}__table`]} ref={tableRef}>
            <table>
              <thead>
                <tr>
                  <th>№</th>
                  {columnKeys.map((key) => (
                    <th key={key}>
                      <div className={classes[`${baseClass}__header`]}>
                        {t(`${translationKey}.table.${key}`)}
                        <SortIcon onClick={() => handleSort(key)} />
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, index) => (
                  <tr key={item.id ?? index}>
                    <td>{index + 1}</td>
                    {columnKeys.map((key) => {
                      let value: string | number | null =
                        key === 'name'
                          ? item[`name${getLang()}`]
                          : item[key as keyof IBudgetInvestmentProjectStats];

                      const formatted =
                        typeof value === 'number'
                          ? value.toLocaleString()
                          : (value ?? '-');

                      return (
                        <td key={key} className={classes[`${baseClass}__cell`]}>
                          {formatted}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>

            {sortedData.length > 10 && (
              <div
                className={classes[`${baseClass}__scroll-to-top`]}
                onClick={scrollToTop}
              >
                <ArrowLeftIcon />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BudgetInvestmentProjectsFullscreen;
